import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as cartActions from '../cartActions';
import { CartItemsList } from './CartItemsList';
import { withRouter } from 'react-router';
import { CartSummary } from './CartSummary';
import classNames from 'classnames/bind';
import styles from '../styles/cartStyles.scss';
import { withTranslation } from 'react-i18next';
import ShoppingData from '../../../business/jsonWrappers/ShoppingData';
import { validateItemsStatus } from '../../../business/validation/validateCartItems';

const cx = classNames.bind(styles);

class CartApp extends Component {
  constructor(props) {
    super(props);

    this.handleItemPurchaseAttributesChanged = this.handleItemPurchaseAttributesChanged.bind(this);

    this.state = {};
  }

  handleCartItemRemoving(item) {
    const { removeCartItem } = this.props;
    removeCartItem(item);
  }

  handleItemPurchaseAttributesChanged(item, option) {
    const { changeItemPurchaseAttributes } = this.props;
    changeItemPurchaseAttributes(item, option.licenseId, option.qualityId);
  }

  handleClearCart() {}

  goToCheckout() {
    const { goToCheckout, location: { search } } = this.props;
    const params = search.slice(1).split('&').reduce((acc, s) => {
      const [k, v] = s.split('=');
      return Object.assign(acc, { [k]: v });
    }, {});
    const { srcId, appDefId } = params;
    const payload = {};
    srcId && (payload.srcId = srcId);
    appDefId && (payload.appDefId = appDefId);
    goToCheckout(payload);
  }

  getPriceFromCartItem(cartItem, shoppingData) {
    const { selectedLicenseId, selectedQualityId, galleryId } = cartItem;

    const objShoppingData = new ShoppingData(shoppingData);
    const pricing = objShoppingData.getPricing(galleryId, selectedLicenseId, selectedQualityId);

    return pricing.price;
  }

  getTotalPrice() {
    const { cartItems, shoppingData } = this.props;

    let total;
    if (!cartItems) {
      total = '0';
    } else {
      total = (cartItems || []).reduce((previousValue, cartItem) => {
        return previousValue + this.getPriceFromCartItem(cartItem, shoppingData);
      }, 0);
    }
    return total;
  }

  componentDidMount() {
    const { mainAppLoaded } = this.props;
    mainAppLoaded();
  }

  render() {
    const { cartItems, shoppingData, site, deviceType, t } = this.props;
    const checkoutLabelText = t('Wix_Provider_UOU_Checkout_Cart_Checkout_Label');
    const areItemsValid = validateItemsStatus(cartItems);

    return (
      <div className={cx(styles.main, 'shop-description')}>
        {!areItemsValid && (
          <div className={cx(styles.invalidItemsContainer)}>
            <div className={cx(styles.invalidContent, styles.invalidItemsBackground, 'shop-button')}/>
            <div className={cx(styles.invalidContent, styles.invalidItemsContent, 'shop-description')}>
              <div className={styles.invalidIcon}/>
              <span className={styles.invalidText}>{t('Wix_Provider_Cart_Items_Invalid_Header')}</span>
            </div>
          </div>
        )}
        <CartItemsList
          site={site}
          items={cartItems}
          shoppingData={shoppingData}
          onItemPurchaseAttributesChanged={(item, license, quality) => this.handleItemPurchaseAttributesChanged(item, license, quality)}
          onCartClear={() => this.handleClearCart()}
          onRemoveItem={item => this.handleCartItemRemoving(item)}
          deviceType={deviceType}
          t={t}
        />
        <CartSummary subtotal={this.getTotalPrice()} site={site} t={t}/>
        <button
          aria-label={checkoutLabelText}
          className={cx('checkoutButton', 'shop-button', { disabled: !cartItems.length })}
          onClick={() => this.goToCheckout()}
        >
          {checkoutLabelText}
        </button>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    site: state.site,
    deviceType: state.deviceType,
    cartItems: state.cartItems,
    shoppingData: state.shoppingData
  };
}

CartApp.propTypes = {
  cartItems: PropTypes.any,
  location: PropTypes.any,
  shoppingData: PropTypes.object,
  site: PropTypes.object,
  changeItemPurchaseAttributes: PropTypes.func,
  removeCartItem: PropTypes.func,
  goToCheckout: PropTypes.func,
  deviceType: PropTypes.any,
  mainAppLoaded: PropTypes.any,
  t: PropTypes.any
};

const ConnectedCartApp = withRouter(connect(mapStateToProps, cartActions)(withTranslation()(CartApp)));

export default ConnectedCartApp;
